import styled, { css, keyframes } from "styled-components";

import { breakpoints, colors, sectionRhythm } from "../../../theme";
import chevron from "../../images/chevron-right.svg";

const TRACK_GAP_PX = 20;

const marqueeScroll = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(calc(-50% - ${TRACK_GAP_PX / 2}px), 0, 0);
  }
`;

export const CarouselRoot = styled.div`
  ${(props) =>
    props.$fullBleed &&
    css`
      margin-inline: 20px;

      @media only screen and (min-width: ${breakpoints.desktop}) {
        margin-inline: auto;
        width: 85%;
      }

      @media only screen and (min-width: 1260px) {
        width: 90%;
      }
    `}
`;

export const CarouselTrack = styled.div`
  display: flex;
  gap: ${TRACK_GAP_PX}px;
  padding: 8px 0;
  width: max-content;

  ${(props) =>
    props.$marquee &&
    css`
      @media only screen and (min-width: ${breakpoints.desktop}) {
        animation: ${marqueeScroll} var(--testimonials-marquee-duration, 60s)
          linear infinite;
        will-change: transform;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
          will-change: auto;
        }
      }
    `}
`;

export const CarouselViewport = styled.div`
  width: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ${(props) =>
    props.$marquee &&
    css`
      @media only screen and (min-width: ${breakpoints.desktop}) {
        overflow: hidden;
        scroll-snap-type: none;
        -webkit-mask-image: linear-gradient(
          to right,
          transparent,
          #000 4%,
          #000 96%,
          transparent
        );
        mask-image: linear-gradient(
          to right,
          transparent,
          #000 4%,
          #000 96%,
          transparent
        );

        &:hover ${CarouselTrack} {
          animation-play-state: paused;
        }

        @media (prefers-reduced-motion: reduce) {
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          -webkit-mask-image: none;
          mask-image: none;
        }
      }
    `}
`;

export const CarouselItem = styled.div`
  flex: 0 0 auto;
`;

export const MasonryContainer = styled.div`
  column-count: 1;
  column-gap: 24px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    column-count: 2;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    column-count: 3;
  }
`;

export const CardSlot = styled.div`
  display: inline-block;
  width: 100%;
  margin-bottom: 24px;
  break-inside: avoid;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: ${sectionRhythm.paddingY.mobile / 2}px;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    margin-top: ${sectionRhythm.paddingY.desktop / 2}px;
  }
`;

export const ArrowIcon = styled.span`
  display: block;
  flex-shrink: 0;
  height: 14px;
  width: 7.5px;
  background-color: ${colors.black};
  mask: url(${chevron}) center / contain no-repeat;
  -webkit-mask: url(${chevron}) center / contain no-repeat;
  transform: ${(props) => (props.$prev ? "rotate(180deg)" : "none")};
  transition: background-color 0.3s ease;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 16px;
    width: 8.5px;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: 18px;
    width: 9.5px;
  }
`;

export const ArrowButton = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
  padding: 0;

  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid ${colors.black};
  background-color: ${colors.accentLight};
  transition: background-color 0.3s ease, border-color 0.3s ease;

  &:hover {
    border-color: ${colors.black};
    background-color: ${colors.black};
  }

  &:hover ${ArrowIcon} {
    background-color: ${colors.white};
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 48px;
    width: 48px;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: 56px;
    width: 56px;
  }
`;
